import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Card from '../components/Card';
import vrHeadset from '../assets/VR.jpg';
import arGlasses from '../assets/AR.jpg';
import vrController from '../assets/VRCONTROL.jpg';
import immersiveApp from '../assets/about.jpg';
import { useEffect } from 'react';
const productsData = [
  { image: vrHeadset, title: 'VR HEADSET' },
  { image: arGlasses, title: 'AR GLASSES' },
  { image: vrController, title: 'VR CONTROLLER' },
  { image: immersiveApp, title: 'IMMERSIVE APP' },
];

function Products() {
   useEffect(() => {
    window.scrollTo(0, 10);
  }, []);

  return (
    <div className="bg-gradient-custom min-vh-100">
      <Navbar />
      <div className="container py-5">
        <h2 className="font-josefin font-light text-4xl text-uppercase text-center mb-5">
          OUR PRODUCTS
        </h2>
        <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-4 g-4">
          {productsData.map((product, index) => (
            <div key={index} className="col">
              <Card image={product.image} title={product.title} />
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Products;